// #region imports

// --- Angular
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

// --- HS Code
import { QuestionCategories, SurveyResultModel, ScoreModel } from '../../../models';

// #endregion

@Component({
  selector: 'hs-results-grid',
  templateUrl: './results-grid.component.html',
  styleUrls: ['./results-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResultsGridComponent implements OnInit {
  @Input() result: SurveyResultModel | null = null;
  @Input() scores: ScoreModel[][] | null = null;

  noResults: ScoreModel[][] | undefined;

  ngOnInit() {

    this.noResults = [
      [
        {categoryName: 'Question_Category_Authentic', categoryType: QuestionCategories.authentic, quadrantName: 'humility', score: 0, index: 1},
        {categoryName: 'Question_Category_Relating', categoryType: QuestionCategories.relating, quadrantName: 'love', score: 0, index: 1}
      ],
      [
        {categoryName: 'Question_Category_Transforming', categoryType: QuestionCategories.transforming, quadrantName: 'humility', score: 0, index: 2},
        {categoryName: 'Question_Category_Encouraging', categoryType: QuestionCategories.encouraging, quadrantName: 'love', score: 0, index: 2}
      ],
      [
        {categoryName: 'Question_Category_Reliable', categoryType: QuestionCategories.reliable, quadrantName: 'humility', score: 0, index: 3},
        {categoryName: 'Question_Category_Developing', categoryType: QuestionCategories.developing, quadrantName: 'love', score: 0, index: 3}
      ],
      [
        {categoryName: 'Question_Category_Achieving', categoryType: QuestionCategories.achieving, quadrantName: 'humility', score: 0, index: 4},
        {categoryName: 'Question_Category_Compassionate', categoryType: QuestionCategories.compassionate, quadrantName: 'love', score: 0, index: 4}
      ],
      [
        {categoryName: 'Question_Category_Sarcastic', categoryType: QuestionCategories.sarcastic, quadrantName: 'pride', score: 0, index: 1},
        {categoryName: 'Question_Category_Approval_Seeking', categoryType: QuestionCategories.approvalSeeking, quadrantName: 'fear', score: 0, index: 1}
      ],
      [
        {categoryName: 'Question_Category_Competitive', categoryType: QuestionCategories.competitive, quadrantName: 'pride', score: 0, index: 2},
        {categoryName: 'Question_Category_Easily_Offended', categoryType: QuestionCategories.easilyOffended, quadrantName: 'fear', score: 0, index: 2}
      ],
      [
        {categoryName: 'Question_Category_Controlling', categoryType: QuestionCategories.controlling, quadrantName: 'pride', score: 0, index: 3},
        {categoryName: 'Question_Category_Dependent', categoryType: QuestionCategories.dependent, quadrantName: 'fear', score: 0, index: 3}
      ],
      [
        {categoryName: 'Question_Category_Striving', categoryType: QuestionCategories.striving, quadrantName: 'pride', score: 0, index: 4},
        {categoryName: 'Question_Category_Avoiding', categoryType: QuestionCategories.avoiding, quadrantName: 'fear', score: 0, index: 4}
      ]
    ];
  }
}
